import React from 'react'

export function PlayingDisclosureView() {
  return <div className="flex flex-row gap-2 items-center text-primary text-sm">Playing capture disclosure...</div>
}
